import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import axios from '../axios'; // baseURL + withCredentials enabled

 import { Link, useNavigate } from 'react-router-dom'; 
 import folder2 from '../assets/folder3.jpeg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faDownload,
  faTrash,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import PDFViewer from "../components/PDFViewer";

const Folders = () => {
  const { id } = useParams(); // current folder id
  const [folders, setFolders] = useState([]); 
  const [folder, setFolder] = useState([]); 
  const [files, setFiles] = useState([]); 
  const [file, setFile] = useState(null);
  const permission = localStorage.getItem('permission');
  const [viewFile, setViewFile] = useState(null);

   const [breadcrumb, setBreadcrumb] = useState([]); 

  // Load folders
 const fetchFolder = async () => {
  if (!id) return;

  try {
    const res = await axios.get('/folders/' + id);
    setFolder(res.data || {});
  } catch (err) {
    console.error('Fetch folders failed:', err);
  }
};

   useEffect(() => {
  if (id) {
    axios.get(`/folders/breadcrumb/${id}`).then(res => {
      setBreadcrumb(res.data || []);
    });
  }
}, [id]);
  
    
const fetchFolders = async () => {
  try {
    let res;

    if (id) {
      res = await axios.get('/subfolders/' + id);
    } else {
      res = await axios.get('/folders'); // root folders
    }

    setFolders(res.data || []);
  } catch (err) {
    console.error('Fetch folders failed:', err);
  }
};

 const fetchFiles = async () => {
  if (!id) {
    setFiles([]);
    return;
  }

  try {
    const res = await axios.get('/files/folder/' + id);
    setFiles(res.data || []);
  } catch (error) {
    console.error("Failed to fetch files", error);
  }
};

  useEffect(() => {
  fetchFolders();
  fetchFiles();
  fetchFolder();
}, [id]);
  

  return (
    <Layout>


      <nav className="text-sm text-gray-600"  style={id ? { display: "none" } : { marginBottom:"40px"}}  >
  <Link to="/folders" className="text-blue-600">Main Folders</Link>
  </nav>

       {id && (
  <nav className="text-sm text-gray-600">
  <Link to="/folders" className="text-blue-600">Main Folders</Link>

  {breadcrumb.map((b, i) => (
    <span key={b.id}>
      {" > "}
      <Link
        to={`/folders/${b.id}`}
        className="text-blue-600"
      >
        {b.name}
      </Link>
    </span>
  ))}
 
   
</nav>
  )}
    <div className="container folder-conatain mt-4" >
      <h2>{id ? folder.name : ""}</h2>

      <div className='dashboard-wrap mt-4'>  
            
               <ul className="list-unstyled">
               
                          {folders.map((folder, index) => (
                        
                           <li className="mb-2" style={!id ? { width: "100%" } : {}}  >
                             <img src={folder2}  className='side-folder'/>
                            <Link to={"/folders/"+folder.id} >{folder.name}</Link>
                             
                           </li>  
                          ))} 
                         
                       </ul>
              </div>  
{id && (
              <table className="w-full   table-basic">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 border">File Name</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {files.length > 0 ? (
            files.map((file, index) => {
           
             const extension = file.name.split('.').pop().toLowerCase();
             const isPdf = extension === "pdf";
           
             return (
              <tr key={file.id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                <td className="p-2 border">{file.name}</td>
                <td className="p-2 border space-x-2">
                  {(file.mode === "read" && isPdf )? (
                      <button
                        className="bg-teal-700 text-white px-3 py-1 rounded btn-action btn-view"
                       onClick={() =>  setViewFile(
                        `${file.file_url}`
                      )}
                      >
                        <FontAwesomeIcon icon={faEye} /> View
                      </button>
                    ) : (
                      <>
                      <a
                        href={file.file_url}
                        target="_blank"
                        download
                        className="bg-blue-900 text-white px-3 py-1 rounded btn-action btn-edit btn-download"
                      >
                        <FontAwesomeIcon icon={faDownload} /> Download 
                      </a>
                      {isPdf &&
                       <button style={{marginLeft:"10px"}}
                        className="bg-teal-700 text-white px-3 py-1 rounded btn-action btn-view"
                       onClick={() =>  setViewFile(
                        `${file.file_url}`
                      )}
                      >
                        <FontAwesomeIcon icon={faEye} /> View
                      </button>
            }
                      </>
                    )}
                   
                </td>
              </tr>
            )})
          ) : (
            <tr>
              <td colSpan="2" className="text-center p-4">
                No files found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
)}
       {viewFile && (
        
          
          <PDFViewer fileUrl={viewFile} onClose={() => setViewFile(null)} />
       
        )}
    </div>
    </Layout>
  );
};

export default Folders;
